import React from 'react';
import { capitalize } from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';

export function talonRegistrationColumns({ t, lang, onView }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
      Cell: ({ index }) => index + 1
    },
    {
      Header: t('talonRegistration_columnId'),
      accessor: 'serviceProviderId',
      width: 100,
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('talonRegistration_columnName'),
      accessor: 'serviceProviderName',
      sortable: false,
      filterable: false,
      Cell: ({ original }) => original[`serviceProvider${capitalize(lang)}Name`] || ''
    },
    {
      Header: t('talonRegistration_columnBin'),
      accessor: 'serviceProviderBin',
      width: 160,
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('talonRegistration_columnLocality'),
      accessor: 'serviceProviderLegalLocality',
      sortable: false,
      filterable: false,
      Cell: ({ original: { serviceProviderLegalLocalityName } }) =>
        serviceProviderLegalLocalityName ? serviceProviderLegalLocalityName[`${lang}_name`] : ''
    },
    {
      Header: t('talonRegistration_columnIsActive'),
      accessor: 'isActive',
      width: 120,
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
      Cell: ({ original }) =>
        original.couponId
          ? t('talonRegistration_registered')
          : original.isActive
          ? t('talonRegistration_active')
          : t('talonRegistration_inactive')
    },
    {
      Header: t('talonRegistration_columnActions'),
      accessor: 'actions',
      width: 100,
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
      Cell: ({ original }) => (
        <IconButton
          size="small"
          title={t('talonRegistration_view')}
          onClick={() => onView(original.id)}
        >
          <VisibilityIcon fontSize="small" color="action" />
        </IconButton>
      )
    }
  ];
}
